import { render, staticRenderFns } from "./SimpleMarkdownViewer.vue?vue&type=template&id=40bb4471&scoped=true&"
import script from "./SimpleMarkdownViewer.vue?vue&type=script&lang=js&"
export * from "./SimpleMarkdownViewer.vue?vue&type=script&lang=js&"
import style0 from "./SimpleMarkdownViewer.vue?vue&type=style&index=0&id=40bb4471&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40bb4471",
  null
  
)

export default component.exports